<template>
  <el-dialog title="Pagar Valor Em Aberto" @open="iniciar" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="600px" v-loading="loading">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="10">
          <el-tag type="warning" size="small">
            {{`Vencimento do Aluguel: ${this.recibo.dataVencimento}`}}
          </el-tag>
        </el-col>
      </el-row>    
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Data do Pagamento">
            <el-date-picker v-model="dataPagamento" v-mask="'##/##/####'" type="date" format="dd/MM/yyyy" value-format="dd/MM/yyyy" style="width: 100%"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-button @click="calcularAluguelHandler" type="primary" size="small" style="margin-top:17px;" round class="btn-box-shadow">Calcular</el-button>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-top: 5px">
        <el-col :span="6">
          <el-tag type="primary" size="small">
            {{`Valor Em Aberto do Recibo: ${this.labelValorEmAberto()}`}}
          </el-tag>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-top: 5px">
        <el-col :span="8">
          <el-form-item label="Valor do Pagamento">
            <money auto-complete="off" v-model="valorPagamento" v-bind="money" class="el-input__inner"/>
          </el-form-item>
        </el-col>   
      </el-row>

      <el-row :gutter="10" style="margin-top: 10px">
        <el-col :span="24">
          <el-table
            :data="itensRecibo"
            empty-text="Nenhum item encontrado"
            size="small"
            height="200"
            style="background-color: #FFFFFF; "
            stripe
            highlight-current-row>
            <el-table-column label="Descrição" prop="nome" show-overflow-tooltip/>
            <el-table-column label="Valor" prop="valor" :formatter="labelValor" width="90"/>
            <el-table-column width="70" column-key="acoes">
              <template slot-scope="scope" v-if="(scope.row.categoria === 'DESCONTO')">
                <el-button @click.native.prevent="removerDesconto(scope.$index,itensRecibo)" type="text" size="small" style="padding: 0px; color: #F56C6C;">Remover</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-top: 15px">
        <el-col :span="18">
          <el-form-item label="Desconto">
            <money auto-complete="off" v-model="desconto" v-bind="money" :disabled="desabilitarDesconto" class="el-input__inner"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
              <el-form-item label=" ">
                <el-button @click="concederDesconto" type="primary" size="small" style="width: 100%" :disabled="desabilitarDesconto" round class="btn-box-shadow">Conceder</el-button>
              </el-form-item>
            </el-col>
      </el-row>      

      <el-row :gutter="10" style="margin-top: 10px" v-if="totalEncargos > 0">
        <el-col :span="24" style="margin-top: 17px; align-items: center;">
          <el-tag type="primary" size="small" style="width: 100%; text-align: center">{{"Total dos Encargos " + this.formatarValor(this.totalEncargos)}}</el-tag>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-top: 15px">
        <el-col :span="24">
          <el-form-item label="Total">
            {{this.formatarValor(this.calcularValorPagar())}}
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <span slot="footer">
        <el-button @click="pagar" type="primary" size="small" round class="btn-box-shadow">Pagar</el-button>
    </span>
  
  </el-dialog>

</template>

<script>
import { mapActions, mapState } from 'vuex'
import Util from '../../../util/funcoes.js';
import { FORMA_RECEBIMENTO, TIPO_ITEM_RECIBO } from '../../../util/constantes.js';
import { Money } from "v-money";

export default {
  props: {
    recibo: Object,
    visibility: Boolean,
  },
  components: {
    Money
  },
  created(){
    this.dataPagamento = Util.hoje() 
    this.calcularAluguelHandler()
  },
  data() {
    return {
      itensRecibo: [],
      valorPagamento: undefined,
      dataPagamento: Util.hoje(),
      calculado: false,
      desconto: 0,
      valorAluguelCalculado: undefined,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

    }
  },
  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "CLIENTES_ALUGUEL" })[0] }
    }),
    formasRecebimento() {
      return FORMA_RECEBIMENTO;
    },
    tipoItem() {
      return TIPO_ITEM_RECIBO;
    },
    desabilitarDesconto(){
      return !this.permissoes.concederDescontoPagarAluguel
    },
    totalEncargos() {
      let total = 0
      this.itensRecibo.forEach(item => {
        if(this.isEncargo(item)) {
          total += item.valor
        }
      });
      return total;
    },
    loading() {
      return this.$store.state.loading;
    },
  },
  watch:{
    dataPagamento: function (newValue, oldValue) {
      if(newValue != oldValue){
        this.calculado = false
      }
    }
  },
  methods: {
    ...mapActions([
        'showLoading',
        'hideLoading'
    ]),
    ...mapActions('alugueisClientesStore', [
        'calcularAluguelValorEmAberto',
        'pagarPagamentoRecibo'
    ]),

    iniciar() {
      this.itensRecibo = []
      this.dataPagamento = Util.hoje()
      this.calcularAluguelHandler()
      
    },
    calcularEncargos(itensRecibo){
      this.itensRecibo.push({valor: this.recibo.valorEmAberto, nome: "Valor em Aberto", tipo: "DEBITO"})
      itensRecibo.forEach(item => {
        if(this.isEncargo(item)){
          this.itensRecibo.push(item);
        }
      })
      this.valorPagamento = this.calcularValorPagar()
    },
    //RECUPERAR ENCARGOS DO RECIBO E CALCULAR O VALOR A SER PAGO
    calcularAluguelHandler() {
      if(!this.dataPagamento) {
        this.$message.warning("Insira a data de Pagamento!");
        return;
      }
        
        let payload = { id: this.recibo.id, dataPagamento: this.dataPagamento }

        this.showLoading();
        this.calcularAluguelValorEmAberto(payload)
        .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
                case "SUCESSO":
                  //somar itens
                  this.reset();
                  this.calcularEncargos(resultado.item.itensRecibo);
                  this.calculado = true;
                  break;
                case "FALHA":
                    this.$message.warning(resultado.mensagem);
                    break;
                default:
                    this.$message.error(resultado.mensagem);
                    break;
            }
        }).catch(() => {
            this.hideLoading();
        });
    },

    pagar() {
      if(this.dadosValidos()) {
        this.showLoading();
        this.pagarPagamentoRecibo({
          dataPagamento: this.dataPagamento,
          valor: this.valorPagamento,
          recibo: {
            id: this.recibo.id,
          },
          desconto: this.desconto,
          valorEmAberto: this.calcularValorPagar(),
          encargos: this.totalEncargos
        })
        .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
                case "SUCESSO":
                    this.$message.success(resultado.mensagem);
                    this.concluirPagamento(resultado);
                    break;
                case "FALHA":
                    this.exibirAlert("Atenção", resultado.mensagem);	
                    break;
                default:
                    this.$message.error(resultado.mensagem);
                    break;
            }
        }).catch(() => {
            this.hideLoading();
        });
      } else {
        if(!this.calculado) {
          this.exibirAlert("Atenção", "Você deve calcular o valor do pagamento antes de dar baixa no pagamento");	
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      }
    },
    //REFORMULAR VALIDAÇÃO
    dadosValidos() {
      var validacao = true;
      
      validacao = (this.calculado) && validacao;      
      return validacao;
    },

    isEncargo(itemRecibo) {
      return itemRecibo.categoria == "MULTA"
        || itemRecibo.categoria == "JUROS"
        || itemRecibo.categoria == "PERMANENCIA_DIARIA"
        || itemRecibo.categoria == "HONORARIOS_ADVOCATICIOS"
    },
    formatarValor(valor) {
      return Util.formatarValor(valor)
    },
    concederDesconto(){
      this.itensRecibo = this.itensRecibo.filter(item => { return item.categoria !== "DESCONTO" });

      if(this.desconto > 0){
        this.itensRecibo.push(this.criarItemDesconto());
      }

      this.valorPagamento = this.calcularValorPagar();
    },

    removerDesconto(index, rows){
      rows.splice(index,1);
      this.valorPagamento = this.calcularValorPagar();
      this.desconto = 0;
    },

    criarItemDesconto(){
      let itemDesconto = {
        nome: "Desconto - Pagamento do Aluguel",
        dataMovimento: this.dataPagamento,
        valor: this.desconto,
        tipo: "CREDITO",
        categoria: "DESCONTO"
      }

      return itemDesconto
    },
    calcularValorPagar() {
      let total = 0.0;
      this.itensRecibo.forEach(item => {
        if(item.tipo === "DEBITO"){
          total += item.valor;
        } else if(item.tipo === "CREDITO") {
          total -= item.valor;
        }
      });      
      return total
    },

    exibirAlert(titulo, mensagem) {
        this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },
    labelTipoRecibo(item){
      return Util.getLabel(this.tipoItem,item.tipo)
    },
    labelValor(item) {
      return Util.formatarValor(item.valor)
    },
    labelValorEmAberto(){
      return Util.formatarValor(this.recibo.valorEmAberto)
    },
    reset(){
      this.itensRecibo = [],
      this.valorAluguelCalculado = undefined,
      this.valorPagamento = 0
      this.calculado = false,
      this.desconto = 0

    },
    concluirPagamento(resultado) {
      this.reset();
      this.$emit('concluirPagamento',resultado);
    },
    fechar() {
      this.reset();
      this.$emit('close');
    } 
  }
}
</script>
